var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0909 12.5899C18.9309 12.5899 18.7709 12.5399 18.6309 12.4299C14.6009 9.3199 9.39091 9.3199 5.36091 12.4299C5.03091 12.6799 4.56091 12.6199 4.31091 12.2999C4.06091 11.9699 4.12091 11.4999 4.44091 11.2499C9.03091 7.6999 14.9609 7.6999 19.5409 11.2499C19.8709 11.4999 19.9309 11.9699 19.6709 12.2999C19.5409 12.4899 19.3209 12.5899 19.0909 12.5899Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0005 9.1099C21.8405 9.1099 21.6805 9.05993 21.5405 8.94993C15.7405 4.46993 8.25052 4.46993 2.46053 8.94993C2.13053 9.19993 1.66052 9.13992 1.41052 8.81992C1.16052 8.48992 1.22051 8.0199 1.54051 7.7699C7.89051 2.8599 16.1005 2.8599 22.4605 7.7699C22.7905 8.0199 22.8505 8.48992 22.5905 8.81992C22.4505 9.00992 22.2205 9.1099 22.0005 9.1099Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2096 16.24C17.0496 16.24 16.8896 16.19 16.7496 16.08C13.8696 13.85 10.1396 13.85 7.24958 16.08C6.91958 16.33 6.44958 16.27 6.19958 15.95C5.94958 15.62 6.00958 15.15 6.32958 14.9C9.76958 12.24 14.2196 12.24 17.6596 14.9C17.9896 15.15 18.0496 15.62 17.7896 15.95C17.6496 16.14 17.4296 16.24 17.2096 16.24Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5992 19.9C14.4392 19.9 14.2792 19.85 14.1392 19.74C12.8392 18.73 11.1492 18.73 9.8492 19.74C9.5192 19.99 9.04919 19.93 8.79919 19.61C8.54919 19.28 8.60918 18.81 8.92918 18.56C10.7892 17.12 13.1892 17.12 15.0492 18.56C15.3792 18.81 15.4392 19.28 15.1792 19.61C15.0492 19.79 14.8292 19.9 14.5992 19.9Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.436091e075a2b2f431abeb9315ee10f6.svg";
export { ForwardRef as ReactComponent };